import {collection, component, field, identifier} from "@fedeltapointofsale/data-client";
import {PriceLevelReferenceData} from "../price-level/price-level.data";
import {PricingScheduleData} from "../pricing-schedule/pricing-schedule.data";
import {TypedTerminalReferenceData} from "../../pos/terminal/terminal-reference.data";

export class PriceLevelScheduleData extends PricingScheduleData<PriceLevelScheduleData> {
    @identifier priceLevelScheduleId: number;
    @field name: string;
    @field allTerminals: boolean = false;
    @field discontinued: boolean;
    @field priceLevelId: number;
    @component priceLevel: PriceLevelReferenceData;
    @collection(TypedTerminalReferenceData) terminals: TypedTerminalReferenceData[];
}
